/* istanbul ignore file */
export { default } from './QuoteFormLegend';
